/**
 * Selects the editing paths.
 * @returns {Selector}
 */
function getPathsEditingSelector () {
  return state => state && state.editing.paths
}

export default getPathsEditingSelector
